<script>
import Gs1AlertLoading from '../../components/alerts/Gs1AlertLoading.vue'
import CompanySearchForm from '../../components/CompanySearchForm.vue'
import CompanyModal from '../../components/CompanyModal.vue'
import MapModal from '../../components/MapModal.vue'
import { searchLicensee } from '../../verifiedapi'
import { saveGet } from '../../mixins/saveGet'
import LangString from '../../components/LangString.vue'

export default {
  components: {
    LangString,
    CompanyModal,
    MapModal,
    Gs1AlertLoading,
    CompanySearchForm
  },
  props: ['query'],
  name: 'Companies',
  data() {
    return {
      loading: false,
      companySearch: {
        licenseeName: '',
        countryCode: '',
        streetAddress: '',
        addressLocality: '',
        postalCode: ''
      },
      results: []
    }
  },
  mixins: [saveGet],
  mounted() {
    this.companySearch = this.query
    this.submitCompanySearch(this.query)
  },
  computed: {
    sortedLicences() {
      return this.results.licences
        .slice()
        .filter(l => !l.licenceKey.startsWith('417'))
        .sort((a, b) => {
          if (a.licenceKey < b.licenceKey) return -1
          if (a.licenceKey > b.licenceKey) return 1
          return 0
        })
    }
  },
  methods: {
    submitCompanySearch(query) {
      this.loading = true
      searchLicensee(query)
        .then(response => {
          this.loading = false
          this.results = response.data
          window.history.replaceState(
            {},
            '',
            '/companies?q=' + encodeURI(JSON.stringify(query))
          )
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    isMainTrue(company) {
      return company.main === true
    }
  },
  i18n: {
    messages: {
      de: {
        license_key: 'Lizenzschlüssel',
        company_name: 'Firma',
        city: 'Stadt',
        country: 'Land',
        options: 'Optionen',
        not_found: 'Es wurde keine Firma gefunden',
        licensee_gln: 'Lizenznehmer GLN',
        more_results:
          'Es gibt insgesamt {totalRecords} Ergebnisse. Nur die ersten 100 werden angezeigt. Bitte stellen Sie feinere Filter ein.'
      },
      en: {
        license_key: 'License Key',
        company_name: 'Company Name',
        city: 'City',
        country: 'Country',
        options: 'Options',
        not_found: 'No company found',
        licensee_gln: 'Licensee GLN',
        more_results:
          'There are {totalRecords} total records. Only 100 are shown. Please add more filters.'
      }
    }
  }
}
</script>

<template>
  <div class="container">
    <h1>Verified by GS1</h1>

    <CompanySearchForm
      v-model="companySearch"
      @submit="submitCompanySearch"
      style="margin-bottom: 25px"
    />

    <gs1-alert-loading v-if="loading" />

    <div
      v-else-if="saveGet(results.licences, []).length > 0"
      class="content-module-wrapper"
      style="border-top-color: transparent"
    >
      <div class="content-module">
        <div class="row">
          <div class="col">
            <table class="table" style="width: 100%">
              <thead>
                <tr>
                  <th>{{ $t('license_key') }}</th>
                  <th>{{ $t('company_name') }}</th>
                  <th>{{ $t('licensee_gln') }}</th>
                  <th>{{ $t('city') }}</th>
                  <th>{{ $t('country') }}</th>
                  <th>{{ $t('options') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="company in sortedLicences" :key="company.licenceKey">
                  <td v-if="company.licenceType === 'GCP'">
                    {{ company.licenceKey }}
                  </td>
                  <td v-else>-</td>
                  <td>
                    <CompanyModal :value="company">
                      <span>
                        {{ company.licenseeName }}
                      </span>
                    </CompanyModal>
                  </td>
                  <td
                    v-if="
                      isMainTrue(company) &&
                      company.licenceType === 'GCP' &&
                      company.licenceKey.length < 12
                    "
                  >
                    {{ saveGet(company, '-', 'licenseeGLN') }}
                  </td>
                  <td v-else>-</td>
                  <td>
                    <MapModal
                      v-if="
                        saveGet(
                          company,
                          false,
                          'address',
                          'addressLocality',
                          'value'
                        )
                      "
                      :value="saveGet(company, null, 'address')"
                      :company="company.licenseeName"
                    >
                      {{
                        saveGet(
                          company,
                          false,
                          'address',
                          'addressLocality',
                          'value'
                        )
                      }}
                    </MapModal>
                    <span v-else> - </span>
                  </td>
                  <td>
                    <lang-string
                      v-if="
                        saveGet(company, '', 'address', 'countryCode')
                          .length === 2
                      "
                      :lang="saveGet(company, '', 'address', 'countryCode')"
                    />
                    <span v-else>-</span>
                  </td>
                  <td>
                    <CompanyModal
                      :value="company"
                      style="display: inline-block"
                    />
                    <div style="display: inline-block; margin-left: 10px">
                      <MapModal
                        v-if="saveGet(company, false, 'address')"
                        :value="saveGet(company, null, 'address')"
                        :company="company.licenseeName"
                      />
                      <span v-else class="fa fa-map text-muted" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <h3 v-else>{{ $t('not_found') }}</h3>
    <h3 v-if="saveGet(results.totalRecords, 0) > 100">
      {{
        $t('more_results', { totalRecords: saveGet(results.totalRecords, 0) })
      }}
    </h3>
  </div>
</template>



// WEBPACK FOOTER //
// src/router/views/Companies.vue